import React, { Component } from 'react';

import { apiReadOneAsset } from '../../../../../utils/apis';
import Button from '../../../../../components/bases/button/button';


import { GlobalContext } from '../../../../../utils/globalprovider';


import imgBase from "./assets/base.png"
import imgDownload from "./assets/download.png"

import "../exportsstyles.css"

class ExportBase extends React.Component
{

    static contextType = GlobalContext;

constructor (props)
{
    super(props);

    this.state = {
        asset: null,
        fileready: false,
    };

    this.apicallbackReadAsset = this.apicallbackReadAsset.bind(this)
    this.onExportDataBase = this.onExportDataBase.bind(this)
    this.onDownload = this.onDownload.bind(this)

    this.fileWorker=null;
}


downloadArrayBuffer(arrayBuffer, filename, unicode = false, bomunicode = false, mimeType = 'application/octet-stream')  
{
    let data = arrayBuffer;

    if (unicode === true && typeof arrayBuffer === 'string') {
        // Conversion de la string JavaScript en UTF-16 LE
        const utf16 = new Uint8Array(arrayBuffer.length * 2);

        for (let i = 0; i < arrayBuffer.length; i++) {
            const code = arrayBuffer.charCodeAt(i);

            utf16[i * 2]     = code & 0xFF;
            utf16[i * 2 + 1] = (code >> 8) & 0xFF;
        }

        if (bomunicode === true) {
            // BOM UTF-16 Little Endian : FF FE
            data = new Uint8Array(utf16.length + 2);
            data[0] = 0xFF;
            data[1] = 0xFE;
            data.set(utf16, 2);
        } else {
            data = utf16;
        }
    }

    const blob = new Blob([data], { type: mimeType });
    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();

    // Clean up
    setTimeout(() => {
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    }, 0);
}



stopComputeFile()
{
    
    this.fileWorker=null;
    this.setState({fileready: false})
}

startComputeFile (formulaire)
{
    this.stopComputeFile();
  
    if( !this.state.asset) return;
    
    var workerdatas = {datas: this.state.asset, formulaire: formulaire};
    this.fileWorker = this.createWorker(); // PURE FUNCTION
    if (!this.fileWorker) return;

    

    this.fileWorker.postMessage(workerdatas);
    this.fileWorker.onmessage = (e) => 
    {
        
        
        var warning = false;
        var error = false;
        
        if ("error" in e.data) error = e.data.error;
        if ("warning" in e.data) warning  = e.data.warning;
        
        if ((error) && (!this.props.stoponerror)) 
        {
            error=false;warning=true;
        }

        if (error)
        {
            if (this.showErrorList)
            {
                const div = document.getElementById("parambodyexport");
                div.scrollTop = 0;
                this.setState({fileready: false})
                this.showErrorList(e.data.errorlist);
            }
            return;
        }
        if (warning)
        {
            if (this.showErrorList) this.showErrorList(e.data.errorlist);
        }
        else
            if (this.showErrorList) this.showErrorList([]);


        this.datasfile = e.data.file;
        this.datasfilename = e.data.filename;
        this.datasunicode = false;
        this.datasbomunicode = false;

        if ("unicode" in e.data) this.datasunicode = e.data.unicode;
        if ("bomunicode" in e.data) this.datasbomunicode = e.data.bomunicode;

        this.setState({fileready: true})

        if (this.props.displaypreview) this.props.displaypreview(this.datasfile)


    }


}


componentDidMount()
{


    if (this.props.asid)
    {
        
        apiReadOneAsset ({asid:this.props.asid}, this.apicallbackReadAsset)   
    }

}                                                                                    
componentDidUpdate()
{
}

componentWillUnmount()
{
    if (this.fileWorker) this.fileWorker.terminate();
    this.fileWorker=null;

}

apicallbackReadAsset(datas)
{
    
    this.setState({asset: datas})
    this.onAssetDownloaded(datas);

}

onExportDataBase()
{
    
}

onDownload()
{
    
    this.downloadArrayBuffer(this.datasfile,this.datasfilename, this.datasunicode, this.datasbomunicode);
}

render(retour)
{

 

    return (
    <div className = "paramsexport_full">
        <div className = "paramsexport_title">
            {this.props.title}
        </div>
        <div className='paramsexport_body' id="parambodyexport">
            {retour}
        </div>
        <div className='paramexport_buttons'>
            <Button 
            button={true}
            image={imgBase}
            tooltip={{"fr":"Exporter vers la base","en":"Export to database"}}
            disable={!this.state.fileready}
            onClick={this.onExportDataBase}
            height={32}  width={32}/>
            &nbsp;
            <Button 
            button={true}
            image={imgDownload}
            tooltip={{"fr":"Télécharger le fichier","en":"Download file"}}
            disable={!this.state.fileready}
            onClick={this.onDownload}
            height={32}  width={36}/>
            &nbsp;&nbsp;
        </div>
    </div>
    )


}

}
ExportBase.defalutProps = {
    stoponerror: false,
}

export default ExportBase;

